import { lazyLoad } from '../../../shared/utils/loadable';

export const ApplicantsPage = lazyLoad(
  () => import('./index'),
  (module) => module.Applicants,
);
